import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=c35e5a8c&scoped=true&"
import script from "./ModalWarning.vue?vue&type=script&lang=js&"
export * from "./ModalWarning.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarning.vue?vue&type=style&index=0&id=c35e5a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e5a8c",
  null
  
)

export default component.exports